module.exports = __webpack_public_path__ + "img/qilin-f-stage5-blink.970ce329.png";